module.exports = __webpack_public_path__ + "assets/icons/logo-auction-ef24.svg";